import type { ReactNode } from 'react';

export function PremiumEmpty({
  icon,
  title,
  action,
  onAction,
  actionLabel,
}: {
  icon: ReactNode;
  title: string;
  action?: ReactNode;
  onAction?: () => void;
  actionLabel?: string;
}) {
  return (
    <div className="flex flex-col items-center rounded-2xl border border-white/8 bg-white/[0.03] px-4 py-5 text-center">
      <div className="mb-2 flex h-10 w-10 items-center justify-center rounded-xl bg-white/[0.06] text-zinc-300">
        {icon}
      </div>
      <p className="text-sm font-semibold text-zinc-200">{title}</p>
      {action ?? (onAction && actionLabel ? (
        <button type="button" onClick={onAction} className="btn-press mt-2 text-xs font-semibold text-accent">
          {actionLabel} →
        </button>
      ) : null)}
    </div>
  );
}
